import toast from "react-hot-toast"
import axios from "axios"

export const getIsAdmin = () => {
    const is_admin = localStorage.getItem('is_admin')
    return is_admin ?? 0
}

export const setIsAdmin = (is_admin) => {
    localStorage.setItem('is_admin', is_admin)
}

export const removeIsAdmin = () => {
    localStorage.removeItem('is_admin')
}

export const getIsSupervisor = () => {
    const is_supervisor = localStorage.getItem('is_supervisor')
    return is_supervisor ?? 0
}

export const setIsSupervisor = (is_supervisor) => {
    localStorage.setItem('is_supervisor', is_supervisor)
}

export const removeIsSupervisor = () => {
    localStorage.removeItem('is_supervisor')
}

export const getIsOwner = () => {
    const is_owner = localStorage.getItem('is_owner')
    return is_owner ?? 0
}

export const setIsOwner = (is_owner) => {
    localStorage.setItem('is_owner', is_owner)
}

export const removeIsOwner = () => {
    localStorage.removeItem('is_owner')
}

export const getParameter = (param_key) => {
    const parameter_str = localStorage.getItem('parameter')

    const parameters = parameter_str ? JSON.parse(parameter_str) : null
    var selectedParameter 
    
    if (parameters !== null) {
        selectedParameter = parameters.find(item => item.param_key == param_key)
    }
    return selectedParameter?.param_value ?? null
}

export const setParameter = (parameter) => {
    localStorage.setItem('parameter', JSON.stringify(parameter))
}

export const removeParameter = () => {
    localStorage.removeItem('parameter')
}

export const getGenericSupplier = () => {
    const supplier_str = localStorage.getItem('supplier')

    try {
        const suppliers = JSON.parse(supplier_str);
        console.log(suppliers);
        return suppliers
    } catch (err) {
        console.log('Error: ', err.message);
        return [{}]
    }
}

export const setGenericSupplier = (supplier) => {
    localStorage.setItem('supplier', JSON.stringify(supplier))
}

export const removeBranchList = () => {
    localStorage.removeItem('branch_list')
}

export const getBranchList = () => {
    const branch_list_str = localStorage.getItem('branch_list')

    try {
        const branch_lists = JSON.parse(branch_list_str);
        console.log(branch_lists);
        return branch_lists
    } catch (err) {
        console.log('Error: ', err.message);
        return [{}]
    }
}

export const setBranchList = (branch_list) => {
    localStorage.setItem('branch_list', JSON.stringify(branch_list))
}

export const removeGenericSupplier = () => {
    localStorage.removeItem('supplier')
}

export const checkPhoneValid = (phone) => {
    if (phone === undefined || phone === null || phone === '' || phone === 'WALKIN') {
        return false
    } else {
        return true
    }
}

export const sendViaWA = async (phone, message) => {
    const maxchat_api = getParameter("MAXCHAT_ID_API_MESSAGE")

    if (!maxchat_api || maxchat_api == '') {
        toast.error("Pengiriman lewat WA belum tersedia!!")
        return
    }

    const checkNumber = (phone) => {
        if (phone.toString().substring(0,2) === "08") {
            phone = "628" +  phone.toString().substring(2)
        } else if (phone.toString().substring(0,2) === "+6")  {
            phone = phone.toString().substring(1)
        }
        return phone
    }

    if (!checkPhoneValid(phone)) {
        toast.error("Phone Number not valid!")
        return false
    }

    toast.loading("Sending WA...", {
        id: "submit"
    })
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    await axios.post(`${maxchat_api}`, {
        "to": checkNumber(phone),
        "type": "text",
        "text": message,
        "useTyping": false
    }, 
    {headers:  
    {
        'Authorization': `Bearer ${process.env.REACT_APP_MAXCHAT_ID}` 
    }
    }).then((response) => {
        if (response.data.status === "pending" || response.data.status === "delivered" || response.data.status === "queue") {
            toast.success("WA sent!", {
                id: "submit"
            })
        } else {
            toast.error(response.data.message, {
                id: "submit"
            })
        }         
    }).catch(error => {
        toast.error(JSON.stringify(error.response.data), {
            id: "submit"
        })
        console.log(error)
    })    
}

export const getMinimumDiscount = (a, b) => {
    if (b == 0 || !b) {
        return a
    }
    if (a == 0 || !a) {
        return b
    }
    if (Number(a) < Number(b)) {
        return Number(a)
    } else {
        return Number(b)
    }
}